import { render, staticRenderFns } from "./PageAccount.vue?vue&type=template&id=30793ac5&"
import script from "./PageAccount.vue?vue&type=script&lang=js&"
export * from "./PageAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30793ac5')) {
      api.createRecord('30793ac5', component.options)
    } else {
      api.reload('30793ac5', component.options)
    }
    module.hot.accept("./PageAccount.vue?vue&type=template&id=30793ac5&", function () {
      api.rerender('30793ac5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/pages/PageAccount.vue"
export default component.exports